import React, { useEffect } from 'react';
import './AlertMsg.scss';
import { ImCross } from "react-icons/im";

function AlertMsg({ message, type, onClose }) {
  useEffect(() => {
    const timer = setTimeout(onClose, 4000); 
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="alert-screen">
      <div className="alert-container">
        <div className={`alert alert-${type}`}>
          <div className="alert-head">
            <h2>{type.charAt(0).toUpperCase() + type.slice(1)}</h2>
            <button className="alert-close" onClick={onClose}><ImCross/></button>
          </div>
          <div className="alert-body">
            <span>{message}</span>
          </div>
          <div className="alert-footer">
            <button className="alert-close" onClick={onClose}>Ok</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AlertMsg;
